import type { ScheduleNode } from "../types.ts";

export function childrenCount(nodes: ScheduleNode[]): Map<string, number> {
	const counts = new Map<string, number>();
	for (const node of nodes) {
		if (!node.parentId) continue;
		counts.set(node.parentId, (counts.get(node.parentId) ?? 0) + 1);
	}
	return counts;
}

export function visibleNodes(
	nodes: ScheduleNode[],
	collapsed: Set<string>,
): ScheduleNode[] {
	const visible: ScheduleNode[] = [];
	let skipDeeperThan: number | null = null;
	for (const node of nodes) {
		if (skipDeeperThan !== null && node.depth > skipDeeperThan) continue;
		skipDeeperThan = collapsed.has(node.id) ? node.depth : null;
		visible.push(node);
	}
	return visible;
}

export function descendants(
	nodes: ScheduleNode[],
	index: number,
): ScheduleNode[] {
	const root = nodes[index];
	if (!root) return [];
	const found: ScheduleNode[] = [];
	for (let cursor = index + 1; cursor < nodes.length; cursor += 1) {
		const node = nodes[cursor];
		if (!node || node.depth <= root.depth) break;
		found.push(node);
	}
	return found;
}

export function leafDescendants(
	nodes: ScheduleNode[],
	index: number,
	counts: Map<string, number>,
): ScheduleNode[] {
	return descendants(nodes, index).filter(
		(node) => (counts.get(node.id) ?? 0) === 0,
	);
}

export function topLevelIndex(nodes: ScheduleNode[]): Map<string, number> {
	const indexes = new Map<string, number>();
	let current = -1;
	for (const node of nodes) {
		if (node.depth === 0) current += 1;
		indexes.set(node.id, Math.max(current, 0));
	}
	return indexes;
}
